import { render } from "./BranchView.vue?vue&type=template&id=362dac99"
import script from "./BranchView.vue?vue&type=script&lang=js"
export * from "./BranchView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__